module.exports = __webpack_public_path__ + "img/nav-archive.5e641da7.svg";